/**
 * Эксперимент главной. Старый лендинг не удаляем.
 * Откат: поставить 'classic' или открыть /?landing=classic
 */
export type HomeLandingVariant = 'classic' | 'editorial';

export const HOME_LANDING_VARIANT: HomeLandingVariant = 'editorial';

export function resolveHomeLandingVariant(search: string): HomeLandingVariant {
  const raw = new URLSearchParams(search).get('landing');
  if (raw === 'classic' || raw === 'editorial') return raw;
  return HOME_LANDING_VARIANT;
}
